import { Component, Input } from '@angular/core';
import { EventItem } from '../../../../interfaces/event';

@Component({
  selector: 'app-portal-event-card',
  templateUrl: './portal-event-card.component.html',
  styleUrls: ['./portal-event-card.component.scss']
})
export class PortalEventCard {
  @Input({ required: true }) event!: EventItem;
}
